import { gql } from "@apollo/client";
import { messageHeaders } from "features/common/fragments";

export const OCR_ID_CARD_PROCESSED = gql`
  subscription ocrIdCardProcessed {
    ocrIdCardProcessed {
      info {
        firstName
        lastName
        series
        gender
        address {
          full
          county
          city
          street
          streetNumber
          buildingNumber
          stair
          floor
          apartment
        }
        issuedByName
        issuedDate
        number
        country
        cNP
        birthDate
        valabilityDate
      }
      success
      errors
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;
